module.exports = __webpack_public_path__ + "static/media/ed-wol.e6297325.png";